import { alignment } from './alignments';
import { animation } from './animations';
import { background } from './backgrounds';
import { border, borderRadius } from './borders';
import { browsers } from './browsers';
import { color } from './colors';
import { css } from './css';
import { frame } from './dimensions';
import { flow } from './flow';
import { font } from './fonts';
import { createToken, get, getTokenValue } from './get';
import { active, focus, hover } from './interactions';
import { mode } from './modes';
import { opacity } from './opacity';
import { position } from './positions';
import { shadow } from './shadows';
import { margin, padding, space } from './spacing';
import { $ } from './style-query';
import { offset, rotate, scale, scaleX, scaleY } from './transforms';
import { value } from './values';
import { zIndex } from './z-index';
export var ui = {
  $: $,
  active: active,
  alignment: alignment,
  animation: animation,
  background: background,
  border: border,
  borderRadius: borderRadius,
  browsers: browsers,
  color: color,
  createToken: createToken,
  css: css,
  flow: flow,
  focus: focus,
  font: font,
  frame: frame,
  get: get,
  getTokenValue: getTokenValue,
  hover: hover,
  margin: margin,
  mode: mode,
  offset: offset,
  opacity: opacity,
  padding: padding,
  position: position,
  rotate: rotate,
  scale: scale,
  scaleX: scaleX,
  scaleY: scaleY,
  shadow: shadow,
  space: space,
  value: value,
  zIndex: zIndex
};